import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TooltipModule } from 'ngx-bootstrap';
import { HttpModule } from '@angular/http';

import { SessionStorage, LocalStorage } from '@bhtp-client-api/base';
import { BhtpComponentModule } from '@bhtp-client-web/component';
import { BhtpRulesServiceModule, BhtpJurisdictionsService } from '@bhtp-client-api/eligibility';

import { SharedModule } from './../shared/shared.module';
import { CoreServicesModule } from './../core-services/core-services.module';
import { EmailQuoteModule } from '../email-quote';

import { PurchaseContainerComponent } from './purchase-container.component';
import { PrimaryTravelerDetailComponent } from './traveler/primary-traveler-detail.component';
import { AdditionalTravelerDetailComponent } from './traveler/additional-traveler-detail.component';
import { AdditionalTravelerListComponent } from './traveler/additional-traveler-list.component';
import { PurchaseForOtherComponent } from './policy-buyer/purchase-for-other.component';
import { PolicyBuyerComponent } from './policy-buyer/policy-buyer.component';
import { TravelersStepComponent } from './travelers-step.component';
import { CoveragesStepComponent } from './coverages-step.component';
import { FlightStepComponent } from './flight-step.component';
import { FinishQuoteStepComponent } from './finish-quote-step.component';
import { PurchaseStepComponent } from './purchase-step.component';
import { TripInformationComponent } from './trip-information/trip-information.component';
import { CustomerSearchComponent } from './customer-search/customer-search.component';
import { OptionalCoverageListComponent } from './coverages/optional-coverage-list.component';
import { PurchaseOptionalCoverageComponent } from './coverages/purchase-optional-coverage.component';
import { PurchaseNavigationService } from './purchase-navigation.service';
import { QuotingService } from './quoting.service';
import { AmbassadorInformationSessionStorage } from './../shared';
export { PurchaseContainerComponent } from './purchase-container.component';

// Keep separated on each line to make merge conflicts easier
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HttpModule,
        BhtpRulesServiceModule,
        BhtpComponentModule.forRoot(),
        CoreServicesModule,
        SharedModule,
        EmailQuoteModule,
        TooltipModule
    ],
    declarations: [
        PurchaseContainerComponent,
        PrimaryTravelerDetailComponent,
        AdditionalTravelerDetailComponent,
        AdditionalTravelerListComponent,
        PolicyBuyerComponent,
        PurchaseForOtherComponent,
        TravelersStepComponent,
        CoveragesStepComponent,
        FlightStepComponent,
        FinishQuoteStepComponent,
        PurchaseStepComponent,
        TripInformationComponent,
        CustomerSearchComponent,
        OptionalCoverageListComponent,
        PurchaseOptionalCoverageComponent
    ],
    exports: [
        PurchaseContainerComponent,
        PolicyBuyerComponent,
        PurchaseForOtherComponent,
    ],
    providers: [
        PurchaseNavigationService,
        SessionStorage,
        LocalStorage,
        QuotingService,
        AmbassadorInformationSessionStorage,
        BhtpJurisdictionsService
    ]
})
export class PurchaseModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/purchase/purchase.module.ts